export default __webpack_public_path__ + "static/media/pancreas_plot_female.81c98037.png";